<template>
    <li
        v-if="hasChildren"
        class="nav-item dropdown"
        v-bind="$attrs"
    >
        <a
            class="nav-link dropdown-toggle"
            :class="item.cls"
            href="#"
            :id="item.title"
            data-bs-toggle="dropdown"
            aria-expanded="false"
        >
            {{ $t(item.title) }}
        </a>
        <ul
            class="dropdown-menu dropdown-menu-dark"
            :aria-labelledby="item.title"
        >
            <li
                v-for="child in item.subitems"
            >
                <Link
                    :href="child.href"
                    class="dropdown-item"
                    :class="child.cls"
                >
                    {{ $t(child.title) }}
                </Link>
            </li>
        </ul>
    </li>

    <li
        v-else
        class="nav-item"
    >
        <Link
            :href="item.href"
            class="nav-link"
            :class="item.cls"
        >
            {{ $t(item.title) }}
        </Link>
    </li>
</template>

<script setup lang="ts">
import type {NavbarItemInterface} from "@/components/helpers/Interfaces.ts";
import {computed} from "vue";
import {Link} from "@inertiajs/vue3";

const { item } = defineProps<{
    item: NavbarItemInterface
}>()

const hasChildren = computed(() =>{
    return item.hasOwnProperty('subitems')
})
</script>

<style scoped>

</style>
